<template>
  <div class="dialog-error" :class="{ 'is-bottom-sheet': isBottomSheet }">
    <div class="text-center">
      <div v-if="showIcon" class="mb-3">
        <!-- <font-awesome-icon icon="times-circle" size="5x" class="icon-error" /> -->
        <img
          :src="`${$baseUrl}svg/fail.svg`"
          alt=""
          class="dialog-alert__icon"
          aria-hidden="true"
        />
      </div>
      <span v-if="header" class="f-bold f-title">{{ header }}</span>
      <p v-if="text" class="text-error f-title-sm mt-3">{{ text }}</p>
      <div v-if="subText" class="text-sub f-body-lg mt-2">{{ subText }}</div>
    </div>

    <div class="modal-qr-v2__actions">
      <c-btn
        block
        variant="confirm-primary"
        @click="$emit('confirm')"
        data-test="error-modal-confirm-btn"
      >
        {{ closeText || $t("confirm") }}
      </c-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogError",
  emits: ["confirm"],
  props: {
    header: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    subText: {
      type: String,
      default: ""
    },
    closeText: {
      type: String,
      default: ""
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: ""
    },
    isBottomSheet: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-error {
  padding: 24px 16px;

  &.is-bottom-sheet {
    // padding: 32px 16px 24px;
  }
}

.text-error {
  margin-bottom: 0;
  color: var(--error-color, #f44336);
}

.text-sub {
  color: var(--font-color, #666);
}

.icon-error {
  color: var(--error-color, #f44336);
}
.dialog-alert__icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
</style>
